/* Copyright 2022- Martin Kufner */
Object.defineProperty(Range.prototype, "props", {
    get() {
        const {collapsed, commonAncestorContainer, endContainer, endOffset, startContainer, startOffset} = this;
        const div = document.createElement("div");
        div.append(this.cloneContents());
        const contents = div.innerHTML;
        return {contents, collapsed, commonAncestorContainer, endContainer, endOffset, startContainer, startOffset, startParent: startContainer.parentNode?.outerHTML, endParent: endContainer.parentNode?.outerHTML};
    }
});